import CreateLongTermPromotion from './CreateLongTermPromotion.container';

export default CreateLongTermPromotion;
